import api from './api';

const authService = {
  login: payload => api.post('/auth/sign_in', payload),
  signUp: payload => api.post('/auth/', payload),
  logout: () => api.delete('auth/sign_out'),
};

export default authService;
